'use strict';

import { debounce, delegate, postJSON, fadeOutSlideUpRemove } from './helpers/utils';

// ---------------------------------------------------------------------------
// Cart badge
// ---------------------------------------------------------------------------

function updateCartBadge(count) {
    count = parseInt(count, 10) || 0;

    // Legacy mini-cart counter
    const legacyBadge = document.querySelector('.shopping_cart_mini__count');
    if (legacyBadge) legacyBadge.innerHTML = count;

    // New masthead badge
    let badge = document.querySelector('.cart__count');

    if (count > 0) {
        if (badge) {
            badge.textContent = count;
        } else {
            const icon = document.querySelector('.cart .cart__icon');
            if (icon) {
                badge = document.createElement('span');
                badge.className = 'cart__count';
                badge.textContent = count;
                icon.insertAdjacentElement('afterend', badge);
            }
        }
    } else if (badge) {
        badge.remove();
    }
}

// ---------------------------------------------------------------------------
// Add to cart
// ---------------------------------------------------------------------------

function addToCartInit() {
    delegate('submit', '.js_form_add_to_cart', (event) => {
        event.preventDefault();

        const form   = event.target.closest('.js_form_add_to_cart');
        const url    = form.getAttribute('action');
        const submit = form.querySelector('button');

        const data = {
            action:     'add_to_cart',
            product_id: (form.querySelector('[name=product_id]') || {}).value || 0,
            quantity:   (form.querySelector('[name=quantity]')   || {}).value || 1,
        };

        submit.disabled = true;
        submit.classList.remove('added_to_cart');
        submit.classList.add('loading');

        postJSON(url, data)
            .then((json) => {
                submit.disabled = false;
                submit.classList.remove('loading');

                if (json.result === 'success') {
                    updateCartBadge(json.cart_count);
                    submit.classList.add('added_to_cart');
                } else {
                    alert(json.message);
                }
            })
            .catch((err) => {
                submit.disabled = false;
                submit.classList.remove('loading');
                alert(err);
            });
    });
}

// ---------------------------------------------------------------------------
// Remove from cart
// ---------------------------------------------------------------------------

function removeFromCartInit() {
    delegate('click', '.js_cart_remove', function (event) {
        event.preventDefault();

        const link      = this;
        const url       = link.getAttribute('href');
        const productId = link.dataset.product_id;

        const data = {
            action:     'remove_from_cart',
            product_id: productId || 0,
        };

        link.classList.add('loading');

        postJSON(url, data)
            .then((json) => {
                link.classList.remove('loading');

                if (json.result === 'success') {
                    updateCartBadge(json.cart_count);

                    const row = link.closest('.order_cart_resp__row_item');
                    if (row) {
                        fadeOutSlideUpRemove(row, 300, 300);

                        setTimeout(() => {
                            const cartWrap   = document.querySelector('.order_cart_wrap');
                            const totalsWrap = document.querySelector('.order_totals__wrap');
                            const formWrap   = document.querySelector('.order_form__wrap');

                            if (cartWrap)   cartWrap.innerHTML   = json.output_cart;
                            if (totalsWrap) totalsWrap.innerHTML  = json.output_totals;

                            if (json.cart_count === 0 && formWrap) {
                                formWrap.innerHTML = '';
                            }
                        }, 620);
                    }
                } else {
                    alert(json.message);
                }
            })
            .catch((err) => {
                link.classList.remove('loading');
                alert(err);
            });
    });
}

// ---------------------------------------------------------------------------
// Update cart (quantity change)
// ---------------------------------------------------------------------------

function updateCartInit() {
    let controller = null;

    const onChange = debounce(function (event) {
        event.preventDefault();

        const input     = this;
        const url       = input.dataset.url;
        const productId = input.name;
        const quantity  = input.value || 0;

        const data = {
            action:     'update_cart',
            product_id: productId || 0,
            quantity,
        };

        if (controller) controller.abort();
        controller = new AbortController();

        input.disabled = true;
        const cartWrap = document.querySelector('.order_cart_wrap');
        if (cartWrap) cartWrap.style.opacity = '0.4';

        fetch(url, {
            method: 'POST',
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            body: new URLSearchParams(data),
            signal: controller.signal,
        })
            .then((res) => {
                if (!res.ok) throw new Error(res.status + ' ' + res.statusText);
                return res.json();
            })
            .then((json) => {
                input.disabled = false;

                if (json.result === 'success') {
                    updateCartBadge(json.cart_count);

                    if (cartWrap) {
                        cartWrap.style.opacity = '1';
                        cartWrap.innerHTML = json.output_cart;
                    }

                    const totalsWrap = document.querySelector('.order_totals__wrap');
                    if (totalsWrap) totalsWrap.innerHTML = json.output_totals;

                    if (json.cart_count === 0) {
                        const formWrap = document.querySelector('.order_form__wrap');
                        if (formWrap) formWrap.innerHTML = '';
                    }
                } else {
                    alert(json.message);
                }
            })
            .catch((err) => {
                if (err.name === 'AbortError') return;
                input.disabled = false;
                alert(err);
            })
            .finally(() => {
                controller = null;
            });
    }, 250);

    delegate('change', '.js_cart_update', onChange);

    delegate('focus', '.js_cart_update', function () {
        setTimeout(() => this.select(), 100);
    });
}

// ---------------------------------------------------------------------------
// Init
// ---------------------------------------------------------------------------

export function init() {
    addToCartInit();
    removeFromCartInit();
    updateCartInit();
}
